import { h } from 'preact';

interface HelpModalProps {
  onClose: () => void;
  title: string;
  description: string;
  children: any;
}

export function HelpModal({ onClose, title, description, children }: HelpModalProps) {
  return (
    <div class="help-modal-backdrop" onClick={onClose}>
      <div class="help-modal" onClick={(e) => e.stopPropagation()}>
        <button class="help-modal-close" onClick={onClose}>
          ×
        </button>
        <h2>{title}</h2>
        <p class="help-modal-description">{description}</p>
        {children}
      </div>
    </div>
  );
}
